import { NgModule, ModuleWithProviders } from '@angular/core';
import { PuiCoreModule } from '../core/index';

import { PuiElementsModule } from './elements/index';
import { PuiLayoutModule } from './layout/index';
import { PuiPagesModule } from './pages/index';

const UI_MODULES = [
    PuiElementsModule,
    PuiLayoutModule,
    PuiPagesModule
];

@NgModule({
    imports: [
        PuiCoreModule,
        UI_MODULES
    ],
    exports: UI_MODULES
})
export class PuiUiModule {
    static forRoot(): ModuleWithProviders {
        return { ngModule: PuiUiModule, providers: [] };
    }
}
